namespace $.$$ {

	export class $shm_hitalama_agent_map_widget_session extends $.$shm_hitalama_agent_map_widget_session {

		server_url() {
			return $shm_hitalama_agent_endpoint.agent_url( 'opencode', 'http://localhost:4096' )
		}

		map() {
			return this.Map_page().map()
		}

		map_id() {
			return this.map().link().str
		}

		agent_profile() {
			return this.$.$shm_hitalama_profile.current()
		}

		override prompt( next?: string ) {
			const profile = this.agent_profile()
			if( !profile ) return super.prompt( next )
			if( next !== undefined ) profile.agent_map_draft( this.map_id(), next )
			return this.prompt_current()
		}

		@ $mol_mem
		prompt_current(): string {
			const profile = this.agent_profile()
			return profile ? profile.agent_map_draft( this.map_id() ) : super.prompt()
		}

		agent_id() {
			const agents = $mol_wire_sync( $shm_hitalama_agent_api ).agents( this.server_url() )
			return agents.some( agent => agent.name === 'hitalama-map' ) ? 'hitalama-map' : ''
		}

		new_session_model() {
			const view = this as any as $shm_hitalama_agent_session
			return view.model_current()
		}

		chat_title() {
			return this.widget().title()
		}

		@ $mol_mem
		override Chat_page() {
			return this.page_with_sessions( super.Chat_page() )
		}

		page_with_sessions< Page extends $mol_page >( page: Page ) {
			const state = page as any
			if( state.$shm_hitalama_agent_map_widget_session_sessions ) return page
			state.$shm_hitalama_agent_map_widget_session_sessions = true

			const tools = page.tools.bind( page )
			page.tools = () => [ this.Map_sessions(), ... tools() ]

			return page
		}

		session_data( next?: Record< string, any > ) {
			const data = this.widget().data() ?? {}
			if( next === undefined ) return data
			this.widget().data({ ... data, ... next })
			return next
		}

		@ $mol_mem
		session_id( next?: string ) {
			if( next !== undefined ) {
				this.session_data({ opencode_session_id: next })
				if( next ) this.map_session_attach( next )
				return next
			}
			const id = this.session_data().opencode_session_id
			return typeof id === 'string' ? id : ''
		}

		session_id_ensure( model = this.new_session_model() ) {
			const stored = this.session_id()
			if( stored ) return stored

			const session = $mol_wire_sync( $shm_hitalama_agent_api ).create_session(
				this.server_url(),
				null,
				model,
			) as $shm_hitalama_agent_api_session
			this.session_id( session.id )
			$shm_hitalama_agent_map_sessions.session_upsert_global( this.server_url(), session )
			return session.id
		}

		session_context_sync( session_id: string ) {
			const app = this.$.$shm_hitalama_app.Root(0)
			const map = this.map()
			const context = {
				session_id,
				client_id: app.mcp_client().client_id(),
				map_id: map.link().str,
				map_title: map.title(),
				url: this.$.$mol_dom_context.document?.location.href ?? '',
			}

			if( this.$.$shm_hitalama_settings.agent_backend() !== 'dsh' ) {
				$mol_wire_sync( $shm_hitalama_agent_api ).mcp_session_context(
						$shm_hitalama_agent_endpoint.mcp_url(),
					context,
				)
			}
		}

		map_context_prompt( session_id: string, client_id: string, map_id: string, map_title: string ) {
			return [
				'Контекст Hitalama карты:',
				`session_id: ${ session_id }`,
				`client_id: ${ client_id }`,
				`map_id: ${ map_id }`,
				`map_title: ${ map_title }`,
				'Во все hitalama tools передавай session_id, client_id и map_id из этого контекста.',
			].join( '\n' )
		}

		outgoing_prompt( session_id: string, text: string ) {
			const app = this.$.$shm_hitalama_app.Root(0)
			const map = this.map()
			const system = this.map_context_prompt(
				session_id,
				app.mcp_client().client_id(),
				map.link().str,
				map.title(),
			)
			const view = this as any as $shm_hitalama_agent_session
			return view.system_prompt_pack( system, text )
		}

		map_session_ids() {
			const value = this.map().store( 'opencode_session_ids' )
			if( Array.isArray( value ) ) return value.filter( item => typeof item === 'string' && item )
			if( typeof value === 'string' ) {
				try {
					const parsed = JSON.parse( value )
					if( Array.isArray( parsed ) ) return parsed.filter( item => typeof item === 'string' && item )
				} catch( error ) {
					return []
				}
			}
			return []
		}

		map_session_attach( session_id: string ) {
			const ids = this.map_session_ids()
			if( ids.includes( session_id ) ) return ids
			const next = [ session_id, ... ids ]
			this.map().store( 'opencode_session_ids', next )
			return next
		}

		@ $mol_mem
		events() {
			return this.$.$shm_hitalama_agent_api_events.make({
				url: ()=> this.server_url(),
				notify: $mol_const( ( event: $shm_hitalama_agent_api_event )=> this.event_handle( event ) ),
			})
		}

		events_native() {
			if( !this.session_id() ) return null
			return this.events().native()
		}

		@ $mol_action
		event_handle( raw: $shm_hitalama_agent_api_event ) {
			const event = raw.payload ?? raw
			const type = event.type
			const props = event.properties ?? {}
			const session_id = props.sessionID
			const view = this as any as $shm_hitalama_agent_session

			if( type === 'server.connected' ) {
				if( this.session_id() ) view.messages_ensure( this.session_id() )
				view.questions_ensure()
				return
			}

			if( type === 'session.created' || type === 'session.updated' ) {
			$shm_hitalama_agent_map_sessions.session_upsert_global(
					this.server_url(),
				$shm_hitalama_agent_map_sessions.session_from_event( props ),
				)
			}

			if( !session_id || session_id !== this.session_id() ) return

			if( type === 'message.updated' ) {
				view.message_info_upsert( session_id, props.info )
				return
			}

			if( type === 'message.removed' ) {
				view.message_remove( session_id, props.messageID )
				return
			}

			if( type === 'message.part.updated' ) {
				view.message_part_upsert( session_id, props.part )
				return
			}

			if( type === 'message.part.removed' ) {
				view.message_part_remove( session_id, props.messageID, props.partID )
				return
			}

			if( type === 'message.part.delta' ) {
				view.message_part_delta( session_id, props.messageID, props.partID, props.field, props.delta )
				return
			}

			if( type === 'question.asked' ) {
				view.question_upsert( props )
				return
			}

			if( type === 'question.replied' || type === 'question.rejected' ) {
				view.question_remove( props.requestID )
				return
			}

			if( type === 'session.idle' || type === 'session.error' || type === 'session.status' ) {
				view.session_event_status( session_id, type, props )
				view.load_messages_later( session_id, 50, true )
			$shm_hitalama_agent_map_sessions.sessions_refresh_global( this.server_url() )
			}
		}

	}

}
